import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AlertModule } from '@feature/alert/alert.module';

import { SnackBarComponent } from './snack-bar.component';
import { SnackBarService } from './snack-bar.service';

export const imports: NgModule['imports'] = [
  AlertModule,
  FlexLayoutModule,
  MatButtonModule,
  MatSnackBarModule,
  MatIconModule,
];

@NgModule({
  declarations: [SnackBarComponent],
  imports: [...imports, CommonModule],
  providers: [SnackBarService],
})
export class SnackBarModule {}
